export enum TypeReseau {
    tous = 'tous',
    triphase = 'triphase',
    basseTensionExclue = 'basseTensionExclue'
}
